export default __webpack_public_path__ + "images/0x994ac01750047b9d35431a7ae4ed312ee955e030.png";